import React, { useEffect, useRef, useState } from 'react'
import { Box, Grid, Skeleton } from '@mui/material'
import TagFilterComponent from './TagFilterComponent'
import MediaList from './MediaList'
import { DropDownElement } from '../DropDownComponent'
import Pagination from '../Pagination'
import useGalleryWidth from '../../../util/useGalleryWidth'
import { EventMedia } from '../../types'

interface IProps {
  mediaData: EventMedia[]
  selected?: EventMedia
  setSelected: (item: any, thumbnail: string | undefined) => void
  activateTagSearch?: boolean
  useRoundImageBorders?: boolean
}

export interface GalleryFilter {
  tags: DropDownElement[]
}

const MediaGalleryComponent: React.FC<IProps> = (props) => {
  const [filter, setFilter] = useState<GalleryFilter>({ tags: [] })
  const [data, setData] = useState<EventMedia[]>()
  const [page, setPage] = useState(1)
  const [filtered, setFiltered] = useState(false)

  const mediaContainerRef = useRef<HTMLDivElement>(null)
  const { itemsPerPage, elementSize } = useGalleryWidth(mediaContainerRef)

  const mediaListView = () => {
    if (filtered && filter.tags.length > 0) {
      filterGalleryData(props.mediaData)
    } else {
      setFiltered(false)
      handlePageChange(props.mediaData)
    }
  }

  const filterGalleryData = (fData: any) => {
    const tempData: any = []
    if (fData) {
      fData.map((elem: any) => {
        let elemExist = false
        elem.tags.map((tag: any) => {
          if ((filter.tags.findIndex(filterTag => filterTag.key === tag.id)) !== -1) {
            elemExist = true
          }
        })
        if (elemExist) tempData.push(elem)
      })
      setPage(1)
      handlePageChange(tempData)
    }
  }

  const handlePageChange = (mData: any, page = 1) => {
    if (mData) {
      const startItem = (page - 1) * itemsPerPage
      const endItem = page * itemsPerPage
      setData(mData.slice(startItem, endItem))
    }
  }

  // eslint-disable-next-line no-unused-vars
  const handleFilter = (tags: GalleryFilter) => {
    setFilter(tags)
    setFiltered(true)
  }

  useEffect(() => {
    mediaListView()
  }, [filter, props.mediaData, itemsPerPage])

  useEffect(() => {
    handlePageChange(props.mediaData, page)
  }, [page])

  return (
    <Grid container ref={mediaContainerRef}>
      {data
        ? (
          <>
            <Grid xs={12} item>
              <Box component='div' style={{ marginBottom: '24px' }}>
                {props.activateTagSearch &&
                  <TagFilterComponent handleFilter={handleFilter} mediaData={undefined} />}
              </Box>
            </Grid>
            <Grid xs={12} item>
              <Box component='div'>
                {data.length !== 0 ? (
                  <MediaList
                    elementSize={elementSize}
                    setSelected={props.setSelected}
                    selected={props.selected}
                    mediaData={data && data}
                    useRoundImageBorders={props.useRoundImageBorders}
                  />
                ) : (
                  <Box
                    sx={{ minHeight: '200px', display: 'flex', justifyContent: 'center', alignItems: 'center' }}
                  >Keine Mediendaten vorhanden
                  </Box>
                )}
              </Box>
            </Grid>
            <Grid xs={12} item>
              <Box component='div' style={{ display: 'flex', justifyContent: 'center' }}>
                {props.mediaData && (
                  <Pagination
                    totalItems={filtered ? data.length : props.mediaData.length}
                    itemsPerPage={itemsPerPage}
                    page={page}
                    setPage={setPage}
                  />
                )}
              </Box>
            </Grid>
          </>
        )
        : (
          <>
            <Skeleton style={{ marginBottom: '24px' }} variant='rectangular' width='100%' height={48} />
            <Box style={{ display: 'flex', flexWrap: 'wrap' }}>
              {[...Array(itemsPerPage)].map((x, i) =>
                <Skeleton
                  key={i} style={{ margin: '2.5px' }} variant='rectangular' width={elementSize}
                  height={105}
                />,
              )}
            </Box>
            <Box style={{ display: 'flex', width: '100%', justifyContent: 'center' }}>
              <Skeleton style={{ marginTop: '24px' }} variant='rectangular' width={305} height={25} />
            </Box>
          </>
        )}
    </Grid>
  )
}

export default MediaGalleryComponent
